// =============================================================================
// ワールド定数・モード判定。逆難読化解析＋実機probeで確定した値（単位m, 海面 y=0）。
// =============================================================================
export const SEA_LEVEL = 0;

// 世界スケール: island.glb が scale×20 の大世界。距離・身長などの表示は実メートルへ換算する。
//   実メートル = world座標 / WORLD_PER_M（目線32→1.6m、距離もこの比で実寸表示）。
export const WORLD_PER_M = 20;
export const toM = (w: number): number => Math.round(w / WORLD_PER_M);

// 実機probe(scripts/probe3.mjs)で確定:
//   島 = Group(500,70,-500) / world bbox x[-7,1042] y[-71,193] z[-1082,52]
//   船 = Group(-600,-9,0)
export const ISLAND_CENTER = { x: 500, z: -500 };
export const SHIP = { x: -600, y: 0, z: 0 };

// 島Groupを scene.children から見つける（中心(500,-500)近傍のGroup）
export function findIsland(scene: any): any {
  for (const c of scene.children) {
    if (c.isGroup && c.position &&
        Math.hypot(c.position.x - ISLAND_CENTER.x, c.position.z - ISLAND_CENTER.z) < 60) {
      return c;
    }
  }
  return null;
}
